const $ = jQuery.noConflict();

export default class EventsSlider {
    constructor() {
        this.slider = $('.events-slider-wrapper');
        this.arrows = this.slider.siblings('.slider-arrows')
    }

    init() {
        this.slider.slick({
            arrows: true,
            dots: false,
            swipe: true,
            slidesToShow: 4,
            infinite: false,
            slidesToScroll: 1,
            prevArrow: this.arrows.find('.arrow-prev'),
            nextArrow: this.arrows.find('.arrow-next'),
            responsive: [
                {
                    breakpoint: 1439,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1023,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    }

}
